module.exports = __webpack_public_path__ + "static/media/404.8108cb66.svg";